/* DSA kortingscodeveld voor winkelwagen en cart drawer. */
if (!customElements.get('dsa-cart-discount')) {
  customElements.define(
    'dsa-cart-discount',
    class DsaCartDiscount extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-dsa-discount-input]');
        this.button = this.querySelector('[data-dsa-discount-button]');
        this.message = this.querySelector('[data-dsa-discount-message]');
        if (!this.input || !this.button || this.dataset.ready) return;
        this.dataset.ready = 'true';

        this.button.addEventListener('click', () => this.apply());
        this.input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          // Voorkom dat Enter het winkelwagenformulier verstuurt.
          event.preventDefault();
          event.stopPropagation();
          this.apply();
        });
      }

      get root() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }

      say(text, state) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.dataset.state = state || 'info';
      }

      async apply() {
        const code = this.input.value.trim();
        if (!code) {
          this.say('Vul eerst een kortingscode in.', 'error');
          this.input.focus();
          return;
        }

        this.toggleAttribute('data-busy', true);
        this.say('Code controleren...', 'info');

        try {
          const response = await fetch(`${this.root}cart/update.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code, sections: 'cart-drawer,cart-icon-bubble' }),
          });
          const cart = await response.json();
          const match = (cart.discount_codes || []).find((d) => String(d.code).toLowerCase() === code.toLowerCase());

          if (match && match.applicable) {
            this.say(`Code ${code.toUpperCase()} is toegepast.`, 'success');
            await this.refresh(cart);
          } else {
            this.say('Deze code is niet geldig voor deze winkelwagen.', 'error');
            // Een niet-toepasbare code wordt door Shopify niet bewaard; ververs wel zodat de drawer klopt.
          }
        } catch (error) {
          console.error(error);
          this.say('Er ging iets mis bij het toepassen van de code. Probeer het opnieuw.', 'error');
        } finally {
          this.removeAttribute('data-busy');
        }
      }

      async refresh(cart) {
        if (this.dataset.context !== 'drawer') {
          setTimeout(() => window.location.reload(), 700);
          return;
        }
        try {
          const sections = cart.sections || {};
          const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
          const keepMessage = this.message ? this.message.textContent : '';
          const fresh = sections['cart-drawer'] && parse(sections['cart-drawer']).querySelector('#CartDrawer');
          const current = document.querySelector('#CartDrawer');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            const drawer = document.querySelector('cart-drawer');
            const overlay = current.querySelector('#CartDrawer-Overlay');
            if (drawer && overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
            const message = current.querySelector('[data-dsa-discount-message]');
            if (message && keepMessage) {
              message.textContent = keepMessage;
              message.dataset.state = 'success';
            }
          }
          const bubble = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
          const bubbleTarget = document.getElementById('cart-icon-bubble');
          if (bubble && bubbleTarget) bubbleTarget.innerHTML = bubble.innerHTML;
          document.dispatchEvent(new CustomEvent('dsa:cart-discount-applied'));
        } catch (error) {
          console.error(error);
          window.location.reload();
        }
      }
    }
  );
}
